var exports = {
  "k": "xe7b6e3d6--b376f4--container",
  "p": "xe7b6e3d6--b376f4--price-info",
};

module.exports = exports;
